import { createRouter, createWebHistory } from 'vue-router';
import ApplicationsSettingsLoader from '@core/classes/Applications/ApplicationsSettingsLoader';
import auth from '@core/services/auth';
import Customer from '@/views/Customer.vue';
import Customers from '@/views/Customers.vue';
import Dashboard from '@/views/Dashboard.vue';
import { EmployeePermissionsType } from '@core/classes/SharedEnums';

const user = () => auth.getTokenPayload();

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			name: 'dashboard',
			component: Dashboard,
		},
		{
			path: '',
			name: 'default',
			component: Dashboard,
		},
		{
			path: '/fimenudeals',
			name: 'fimenudeals',
			component: () => import(`@/views/FIMenuDeals.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessDealsPage)) next();
				else next('/');
			},
		},
		{
			path: '/cashbash',
			name: 'cashbash',
			component: () => import(`@/views/CashBash/CashbashAdmin.vue`),
		},
		{
			path: '/cashbash/player',
			name: 'cashbashplayer',
			component: () => import(`@/views/CashBash/CashbashPlayer.vue`),
		},
		{
			path: '/customers',
			name: 'customers',
			component: Customers,
			beforeEnter: (to, from, next) => {
				if (!user().hasAccessToPermission(EmployeePermissionsType.AccessCustomersPage)) next('/');
				// Loads customer applications questions into the class. Optimization.
				ApplicationsSettingsLoader.init().then(() => {
					next();
				});
			},
		},
		{
			path: '/customer',
			name: 'customer',
			component: Customer,
			beforeEnter: (to, from, next) => {
				if (!user().hasAccessToPermission(EmployeePermissionsType.AccessCustomersPage)) next('/');
				// Loads customer applications questions into the class. Optimization.
				ApplicationsSettingsLoader.init().then(() => {
					next();
				});
			},
		},
		{
			path: '/reports',
			name: 'reports',
			component: () => import(`@/views/Reports.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessReportsPage)) next();
				else next('/');
			},
		},
		{
			path: '/accounting',
			name: 'accounting',
			component: () => import(`@/views/Accounting.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessAccountingPage)) next();
				else next('/');
			},
		},
		{
			path: '/admin',
			name: 'admin',
			component: () => import(`@/views/admin/Admin.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessSettingsPage)) next();
				else next('/');
			},
		},
		{
			path: '/utilities/',
			name: 'utilities',
			component: () => import(`@/views/utilities/Utilities.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessUtilitiesPage)) next();
				else next('/');
			},
		},
		{
			path: '/sandbox',
			name: 'sandbox',
			component: () => import(`@/sandbox/Sandbox.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessSandboxPage)) {
					next();
				} else next('/');
			},
		},
		{
			path: '/cancel-coverage',
			name: 'cancelCoverage',
			component: () => import(`@/views/cancel-coverage/CancelCoverage.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessCancelCoveragePage)) next();
				else next('/');
			},
		},
		{
			path: '/cancel-coverage/:id',
			name: 'cancelCoverageDetails',
			component: () => import(`@/views/cancel-coverage/CancelCoverageDetails.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.ViewCancellation)) next();
				else next('/');
			},
		},
		{
			path: '/service',
			name: 'service',
			component: () => import(`@/views/SaturnServiceLookup.vue`),
			beforeEnter: (to, from, next) => {
				if (user().hasAccessToPermission(EmployeePermissionsType.AccessServiceLookupPage)) next();
				else next('/');
			},
		},
	],
});

// router.afterEach((to, from) => {
//     modalService.closeAll()
// });

export default router;
